import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for   Mapvalues
export const Mapvalues = createSlice({
  name: "Mapvalues",
  initialState: {
    api_completed: false,
    isLoading: false,
    isSuccess: false,
    switch: false,
    data: {},
  },
  reducers: {
    Mapvalues_datagrid: (state, a) => {
      state.data = a.payload;
      state.switch = true
    },
    success_api_call_Mapvalues_datagrid: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
    },
    failure_api_call_Mapvalues_datagrid: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.api_completed = true;
    },
    Mapvalues_datagrid_is_success: (state, action) => {
      state.isSuccess = false;
    },
    create_Mapvalues_datagrid_complete_api: (state, action) => {
      state.api_completed = false;
    },
    false_switchMapvalues:(state)=>{
        state.switch = false
    }
  },
});
export default Mapvalues.reducer;
export const {
  Mapvalues_datagrid,
  success_api_call_Mapvalues_datagrid,
  failure_api_call_Mapvalues_datagrid,
  create_Mapvalues_datagrid_complete_api,
  Mapvalues_datagrid_is_success,false_switchMapvalues
} = Mapvalues.actions;
